import { call, put } from 'redux-saga/effects';
import { showLoader, hideLoader } from 'store/commons/actions';
import {
  getDailyRentContractsListSucceed,
  getDailyRentContractsListFailed,
  getListOfDRContractsForExcelSucceed,
  getListOfDRContractsForExcelFailed,
  closeContractSucceed,
  closeContractFailed,
  getCloseContractDetailsSucceed,
  getCloseContractDetailsFailed,
} from 'store/dailyRentContracts/actions';
import { getReservationInfoSucceed } from 'store/reservations/actions';
import {
  getDailyRentContracts,
  getAllDailyRentContracts,
  closeRDContract,
  cancelRDContract,
  getCloseDetailsOfCloseRDContract,
  saveContractRefund,
  saveContractPay,
  getTotalPay,
  cancelPromissoryNote,
  sendCancelledPromissoryNote,
} from 'services/dailyRentContracts';
import {
  getTotalPayFailed,
  getTotalPaySucceed,
  saveContractRefundFailed,
  saveContractRefundSucceed,
  cancelPromissoryNoteSucceed,
  cancelPromissoryNoteFailed,
  sendCancelledPromissoryNoteSucceed,
  sendCancelledPromissoryNoteFailed
} from './actions';

export function* getDailyRentContractsSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(getDailyRentContracts, action.payload.params);
    yield put(getDailyRentContractsListSucceed(data));
  } catch (error) {
    yield put(getDailyRentContractsListFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* getListOfDRContractsForExcelSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(getAllDailyRentContracts, action.payload.params);
    yield put(getListOfDRContractsForExcelSucceed(data));
  } catch (error) {
    yield put(getListOfDRContractsForExcelFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* closeContractSaga(action) {
  try {
    yield put(showLoader());
    const { name, uuid, authReq } = action.payload;
    const data =
      name === 'closeContract'
        ? yield call(closeRDContract, uuid, authReq)
        : yield call(cancelRDContract, uuid, authReq);
    yield put(closeContractSucceed(data));
  } catch (error) {
    yield put(closeContractFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* getCloseContractDetailsSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(getCloseDetailsOfCloseRDContract, action.payload);
    yield put(getReservationInfoSucceed(data.reservationData));
    yield put(getCloseContractDetailsSucceed(data));
  } catch (error) {
    yield put(getCloseContractDetailsFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* saveContractRefundSaga({ payload = {} }) {
  try {
    yield put(showLoader());
    const data = yield call(saveContractRefund, payload);
    yield put(saveContractRefundSucceed(data));
  } catch (error) {
    yield put(saveContractRefundFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* saveContractPaySaga({ payload = {} }) {
  try {
    yield put(showLoader());
    const data = yield call(saveContractPay, payload);
    yield put(saveContractRefundSucceed(data));
  } catch (error) {
    yield put(saveContractRefundFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* getTotalPaySaga({ payload = {} }) {
  try {
    yield put(showLoader());
    const data = yield call(getTotalPay, payload);
    yield put(getTotalPaySucceed(data));
  } catch (error) {
    yield put(getTotalPayFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* cancelPromissoryNoteSaga({ payload = {} }) {
  try {
    yield put(showLoader());
    yield call(cancelPromissoryNote, payload);

    yield put(cancelPromissoryNoteSucceed());
  } catch (error) {
    yield put(cancelPromissoryNoteFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* sendCanceledPromissoryNoteSaga({ payload = {} }) {
  try {
    yield put(showLoader());
    yield call(sendCancelledPromissoryNote, payload);
    yield put(sendCancelledPromissoryNoteSucceed());
  } catch (error) {
    yield put(sendCancelledPromissoryNoteFailed(error));
  } finally {
    yield put(hideLoader());
  }
}
